<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="
					selectedUrl
						? `master/product-type/${inputs.product_type_id}`
						: `master/product-type`
				"
			>
				<div class="form-group row align-items-center">
					<label
						for="inputs_type_id"
						class="col-sm-3 mb-0"
					>
						Lesson Plan Type ID
					</label>
					<app-input
						id="inputs_type_id"
						class="col-sm-9"
						type="text"
						v-model="inputs.type_id"
						:placeholder="'Lesson Plan Type ID'"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label
						for="inputs_product_type_code"
						class="col-sm-3 mb-0"
					>
						Lesson Plan Type Code
					</label>
					<app-input
						id="inputs_product_type_code"
						class="col-sm-9"
						type="text"
						v-model="inputs.product_type_code"
						:placeholder="'Lesson Plan Type Code'"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label
						for="inputs_product_type_desc"
						class="col-sm-3 mb-0"
					>
						Lesson Plan Type Desc
					</label>
					<app-input
						id="inputs_product_type_desc"
						class="col-sm-9"
						type="text"
						v-model="inputs.product_type_desc"
						:placeholder="'Lesson Plan Type Desc'"
						:required="true"
					/>
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";

export default {
	name: "ModalForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		value: {
			type: Object,
			default: () => {
				return {
					id: undefined,
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			inputs: {},
			// statusLists: [
			//     {id: '', value: "Choose One",},
			//     {id: 'active', value: "Active",},
			//     {id: 'inactive', value: "Inactive",},
			//     {id: 'invited', value: "Invite",},
			// ],
			// genderLists: [
			//     {id: 'male', value: "Male"},
			//     {id: 'female', value: "Female"},
			//     {id: 'other', value: "Other"},
			// ],
			modalId: this.formId,
			modalTitle: this.$t("add"),
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}
	},
	methods: {
		submit() {
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			if (response.data.phone) this.phone = response.data.phone;
			this.inputs = response.data;
			this.preloader = false;
		},
	},
};
</script>
